import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const includes = ['Teoría clara y actualizada (Curtis, Campbell, Tortora)', 'Actividades de menor a mayor complejidad', 'Experiencias de Laboratorio "Low Cost" (con materiales de cocina)', 'Infografías y diagramas en alta calidad para imprimir', 'Bibliografía y glosario técnico'];
export function IncludesSection() {
  return <section className="py-12 md:py-20 px-4 bg-brand-light" data-id="element-192">
      <div className="max-w-4xl mx-auto" data-id="element-193">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-6 md:mb-12" data-id="element-194">
          Cada tomo incluye:
        </h2>

        <div className="bg-white p-5 md:p-12 rounded-3xl shadow-xl mb-8 md:mb-12" data-id="element-195">
          <ul className="space-y-4 md:space-y-6" data-id="element-196">
            {includes.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-197">
                <div className="bg-brand-green/10 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-198">
                  <CheckIcon className="w-6 h-6 text-brand-green" strokeWidth={3} data-id="element-199" />
                </div>
                <span className="text-xl font-medium text-gray-800" data-id="element-200">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-201">
          <CTAButton text="→ QUIERO TODO ESTO AHORA" href="#compra" data-id="element-202" />
        </div>
      </div>
    </section>;
}